import Link from '@blackbird/ui-base/link';
import { OpenInBrowser } from '@mui/icons-material';
import { Button } from '@mui/material';
import * as Schema from 'generated/graphql/schema';
import * as React from 'react';

import * as Types from '@/types';

import { TabPanelComponent, TabPropsType } from '.';

const isShown = (peripheral: Partial<Schema.Peripheral>) => {
  // NOTE: Until this is functional, we hide this from the user.
  return Types.isSensor(peripheral) && peripheral && peripheral.peripheralInformation !== undefined;
};

export const TabProps: TabPropsType = {
  isShown: (_, p) => !!p && isShown(p),
  label: (t) => t('device:lineSetup', { defaultValue: 'Line' }),
};

export const TabPanel: TabPanelComponent<{
  peripheral: Partial<Schema.Peripheral>;
}> = ({ peripheral, classes, invalidFormMessage, t }) => {
  if (!isShown(peripheral)) {
    return null;
  }
  const existingLine =
    Types.isSensor(peripheral) &&
    peripheral &&
    peripheral.peripheralInformation &&
    peripheral.peripheralInformation.line;

  return (
    <div className={classes.tabPanel}>
      <div className={classes.centeredContainer}>
        {!existingLine ? (
          <Link
            href={{
              pathname: '/lines',
              query: {
                action: 'create',
                device: `${peripheral && peripheral.peripheralId}`,
              },
            }}
          >
            <Button color="primary" variant="contained">
              <OpenInBrowser style={{ paddingRight: '5px' }} />
              {t(['line:createLine'], { defaultValue: 'Create line' })}
            </Button>
          </Link>
        ) : (
          <Link href={{ pathname: '/line', query: { lineId: existingLine.id, tab: 'live' } }}>
            <Button color="primary" variant="contained">
              <OpenInBrowser style={{ paddingRight: '5px' }} />
              {t(['line:goToLine'], { defaultValue: 'Go to line' })}
            </Button>
          </Link>
        )}
      </div>
      {invalidFormMessage}
    </div>
  );
};
